export default "__VITE_ASSET__B545alq1__"